import * as go from 'gojs';
import * as uuid from 'uuid';
import { getPointString, getSizeString } from '../../../../../utils/stringify-utils';
import { shadowModelToGojsData } from '../../../utils/shadow-utils';
import {
  LAYER_NAME_PROP,
  SHADOW_BLUR_PROP,
  SHADOW_COLOR_PROP,
  SHADOW_OFFSET_PROP,
  Z_ORDER_PROP,
} from '../../common/config/common-prop-names';
import { ShapeNodeCreateProps } from '../models/shape-node-create-props';
import { ShapeNode } from '../models/shape-node.model';
import { bringToFront } from './../../../../../utils/bring-to-front-back/bring-to-front';

export const createShapeNode = (
  diagram: go.Diagram,
  {
    defaultBackground,
    width,
    height,
    geometryString,
    categoryName,
    defaultBorderColor,
    defaultLocked,
    defaultShadow,
    location,
  }: ShapeNodeCreateProps,
) => {
  const gojsShadow = shadowModelToGojsData(defaultShadow, SHADOW_BLUR_PROP, SHADOW_COLOR_PROP, SHADOW_OFFSET_PROP);

  const key = uuid.v4();

  diagram.commit(() =>
    diagram.model.addNodeData(
      new ShapeNode(
        key,
        categoryName,
        geometryString,
        defaultBackground,
        defaultBorderColor,
        defaultLocked,
        getSizeString(width, height),
        getPointString(location.x, location.y),
        gojsShadow[SHADOW_COLOR_PROP] as string,
        gojsShadow[SHADOW_OFFSET_PROP] as string,
        gojsShadow[SHADOW_BLUR_PROP] as number,
      ),
    ),
  );

  const node = diagram.findNodeForKey(key);
  if (node) {
    bringToFront(node, Z_ORDER_PROP, LAYER_NAME_PROP);
  }

  return node;
};
